/**
 * « Suivi des inscriptions » (`live-registrations`): the page has its own head (no OrganizerStickyHead),
 * so the first step targets `live-head`. The activity feed exists only when the backend serves it.
 */
export const LIVE_REGISTRATIONS_TOUR = {
    id: 'live-registrations',
    version: 1,
    paths: ['live-registrations'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="live-head"]',
            placement: 'bottom',
            title: 'Registration, live',
            description:
                'Follow registrations as they come in. The page refreshes by itself, no need to reload it. « View event page » opens your public page.',
        },
        {
            key: 'tiles',
            target: '[data-tour="live-tiles"]',
            placement: 'bottom',
            title: 'Where you stand',
            description:
                'Confirmed athletes, people registering right now, people waiting for a spot and the spots left.',
        },
        {
            key: 'divisions',
            target: '[data-tour="live-divisions"]',
            placement: 'top',
            placementNarrow: 'bottom',
            title: 'Category by category',
            description:
                'For each category: the spots, who is confirmed, who is in progress and what is left. The bar under each row shows how full it is.',
        },
        {
            key: 'feed',
            target: '[data-tour="live-feed"]',
            placement: 'left',
            placementNarrow: 'top',
            title: 'The latest moves',
            description: 'Each registration, cancellation or released spot appears here as it happens.',
        },
    ],
}

export default LIVE_REGISTRATIONS_TOUR
